import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowRight, FiLock, FiUser } from "react-icons/fi";
import { useAuth } from "../../context/AuthContext";
import { useNotification } from "../../context/NotificationContext";
import fullLogo from "../../assets/images/darkthemelogo.svg";

const Login = () => {
  const navigate = useNavigate();
  const { notify } = useNotification();
  const { login } = useAuth();
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login({ username: form.username.trim(), password: form.password });
      notify({ type: "success", title: "Login successful" });
      navigate("/dashboard/content/home", { replace: true });
    } catch (err) {
      const apiMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Login failed. Please check your credentials.";
      setError(apiMessage);
      notify({ type: "error", title: "Login failed", message: apiMessage });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-h-screen bg-slate-100 flex items-center justify-center px-4 py-10" dir="ltr" lang="en">
      <div className="w-full max-w-md rounded-2xl bg-white shadow-xl border border-slate-200 p-8">
        <div className="flex flex-col items-center mb-8">
          <img src={fullLogo} alt="IRQGYP" className="h-14 w-auto mb-4" />
          <h1 className="text-2xl font-bold text-slate-900">Welcome back</h1>
          <p className="text-slate-500 mt-1 text-sm">Sign in to continue</p>
        </div>

        <form onSubmit={onSubmit} className="space-y-4">
          <label className="block">
            <span className="text-sm text-slate-700">Username</span>
            <div className="mt-1 relative">
              <FiUser className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="text"
                required
                value={form.username}
                onChange={onChange("username")}
                className="w-full rounded-xl border border-slate-300 pl-10 pr-4 py-3 outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter your username"
              />
            </div>
          </label>

          <label className="block">
            <span className="text-sm text-slate-700">Password</span>
            <div className="mt-1 relative">
              <FiLock className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="password"
                required
                minLength={6}
                value={form.password}
                onChange={onChange("password")}
                className="w-full rounded-xl border border-slate-300 pl-10 pr-4 py-3 outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter your password"
              />
            </div>
          </label>

          {error && (
            <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#0b2a5b] hover:bg-[#153a77] text-white font-semibold py-3 rounded-xl transition disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {loading ? "Signing in..." : "Sign in"}
            <FiArrowRight className="dir-arrow" />
          </button>
        </form>
      </div>
    </section>
  );
};

export default Login;
